module.exports = "/images/ny-life1-13.jpg";